import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormPreviewSetupWithNotesComponent } from '@app/modules/vault/components/add-document/mini-form-creation/set-up-form-creation/form-preview-setup/form-preview-setup-with-notes/form-preview-setup-with-notes.component';
import { FormPreviewSetupComponent } from '@app/modules/vault/components/add-document/mini-form-creation/set-up-form-creation/form-preview-setup/form-preview-setup.component';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';

import { DocumentService } from '@app/shared/services';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'template-details',
  templateUrl: './template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryTemplateComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  loadingItems = [{ id: 1 }, { id: 2 }, { id: 3 }];
  @Input() data;
  @Output() dTemplateEmitter: EventEmitter<any> = new EventEmitter();
  @ViewChild(FormPreviewSetupComponent) childComponent: FormPreviewSetupComponent;
  @ViewChild(FormPreviewSetupWithNotesComponent) FormPreviewSetupWithNotes: FormPreviewSetupWithNotesComponent;
  currentuserId;
  loadOnce = true;
  disable_btn = false;
  Form1 = [];
  form_name;
  formEncryptionKey;
  saveResponse;
  id;
  securityStateObject;
  is_loading = true;
  JsonDataExtractedData;
  saveFormValueInDb: any;
  fId;
  constructor(
    private toastr: ToastrService,
    private cd: ChangeDetectorRef,
    private loginService: LoginStoreEffects,

    private documentService: DocumentService
  ) {}
  enableSaveFun(event) {
    this.disable_btn = event;
    this.cd.detectChanges();
  }
  updateDbFun(event) {
    this.getFormData();
  }
  parentFun(event) {
    this.saveForm(event);

    this.cd.detectChanges();
  }
  ngOnInit(): void {
    try {
      this.data.action_type_config = JSON.parse(this.data.action_type_config);
      if (this.data.action_type_config.length > 1) {
        this.disable_btn = true;
      }
    } catch (error) {}
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state?.data) {
          this.currentuserId = state.data.id;
          if (this.loadOnce) {
            this.loadOnce = false;
            this.getFormData();
          }
        }
      })
    );
  }
  getFormData() {
    this.subscription.add(
      this.documentService.getformTempletByid(this.currentuserId, this.data.vault_user_form_id).subscribe((res) => {
        res = res['data'];
        this.securityStateObject = res.publicKey;
        this.id = res['vaultFormData'][0].id;
        this.fId = res['vaultFormData'][0]?.fid;
        this.Form1 = JSON.parse(res.vaultFormData[0].template);
        try {
          let Jdata = JSON.parse(res.vaultFormData[0].form_data);
          this.JsonDataExtractedData = Jdata.dynamicFieldsForm;
        } catch (error) {
          this.JsonDataExtractedData = {};
        }
        try {
          this.form_name = res.vaultFormData[0].form_name;
        } catch (error) {}
        this.is_loading = false;
        this.cd.detectChanges();
      })
    );
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  save() {
    this.FormPreviewSetupWithNotes.nextReminder();
    this.dTemplateEmitter.emit({ status: 'forward', id: this.data.id });
  }

  async saveForm(data) {
    const obj = {
      dynamicFieldsForm: data['dynamicFieldsForm'][0],
      beneFicaryForm: [],
      showNotes: data['showNotes'],
    };

    let request = {
      user_id: this.securityStateObject.userId,
      user_pk: this.securityStateObject.public_key,
      id: this.id,
      form_data: obj,
      notes: '',
      physical_location: '',
    };
    if (this.Form1 != null && this.Form1.length != 0) {
      const multiDropMainStack = this.Form1[0]['singleFieldForm'].filter((x) => x.type == 'MultiPleDropDown');
      let multidropDownFomllist = [];
      multiDropMainStack.forEach((element) => {
        if (element && element['data']) {
          element['data'].forEach((childelement) => {
            if (childelement && childelement['template']) {
              multidropDownFomllist = multidropDownFomllist.concat(childelement['template']);
            }
          });
        }
      });
      for (let key of Object.keys(request['form_data']['dynamicFieldsForm'])) {
        const originalData = request['form_data']['dynamicFieldsForm'][key];

        const tempIndex = this.Form1[0]['singleFieldForm'].findIndex((x) => x.formControlName == key);
        if (tempIndex != -1) {
          const currnetTmplateObj = this.Form1[0]['singleFieldForm'][tempIndex];

          if (currnetTmplateObj['type'] == 'date') {
            if (originalData == '' || originalData == null || originalData == undefined) {
            } else {
              const date = new Date(request['form_data']['dynamicFieldsForm'][key]);
              if (Object.prototype.toString.call(date) === '[object Date]') {
                // it is a date
                if (isNaN(date.getTime())) {
                  // d.valueOf() could also work
                  // date is not valid
                } else {
                  const neddddDatae = date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
                  request['form_data']['dynamicFieldsForm'][key] = neddddDatae.toString();
                }
              } else {
                // not a date
              }
            }
          }
        } else {
          const CtempIndex = multidropDownFomllist.findIndex((x) => x.formControlName == key);
          if (CtempIndex != -1) {
            const currnetTmplateObj = multidropDownFomllist[CtempIndex];
            if (currnetTmplateObj['type'] == 'date') {
              if (originalData == '' || originalData == null || originalData == undefined) {
              } else {
                const date = new Date(request['form_data']['dynamicFieldsForm'][key]);
                if (Object.prototype.toString.call(date) === '[object Date]') {
                  // it is a date
                  if (isNaN(date.getTime())) {
                    // d.valueOf() could also work
                    // date is not valid
                  } else {
                    const neddddDatae = date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
                    request['form_data']['dynamicFieldsForm'][key] = neddddDatae.toString();
                  }
                } else {
                  // not a date
                }
              }
            }
          }
        }
      }

      let beneFicaryFormListStack = [];
      this.Form1[0]['multiFieldForm'].forEach((element) => {
        beneFicaryFormListStack = beneFicaryFormListStack.concat(element['template']);
      });
      request['form_data']['beneFicaryForm'].forEach((element, outerindex) => {
        Object.keys(element).forEach((Outerelementkey) => {
          request['form_data']['beneFicaryForm'][outerindex][Outerelementkey].forEach((element, inneIndex) => {
            for (let innerKey of Object.keys(element)) {
              const tempIndex = beneFicaryFormListStack.findIndex((x) => x.formControlName == innerKey);
              if (tempIndex != -1) {
                const currnetTmplateObj = beneFicaryFormListStack[tempIndex];
                if (currnetTmplateObj['type'] == 'date') {
                  const originalData = request['form_data']['beneFicaryForm'][outerindex][Outerelementkey][inneIndex][innerKey];
                  if (originalData == '' || originalData == null || originalData == undefined) {
                  } else {
                    const date = new Date(request['form_data']['beneFicaryForm'][outerindex][Outerelementkey][inneIndex][innerKey]);

                    if (Object.prototype.toString.call(date) === '[object Date]') {
                      // it is a date
                      if (isNaN(date.getTime())) {
                        // d.valueOf() could also work
                        // date is not valid
                      } else {
                        const neddddDatae = date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
                        request['form_data']['beneFicaryForm'][outerindex][Outerelementkey][inneIndex][innerKey] = neddddDatae.toString();
                      }
                    } else {
                      // not a date
                    }
                  }
                }
              }
            }
          });
        });
      });
    } else {
      delete request['form_data'];
      delete request['vault_form_id'];
    }

    // if (this.mode == 'edit') {
    request['security_key'] = null;
    this.subscription.add(
      this.documentService.updateFormTampletData(request, undefined, undefined, undefined, false, undefined).subscribe((res) => {
        this.getFormData();
        // this.dTemplateEmitter.emit({ status: 'forward', id: this.data.id });
      })
    );
  }

  back() {
    this.dTemplateEmitter.emit({ status: 'backward' });
  }
}
